export const kitchen_cooking = [
  { char: '🧑‍🍳', name: 'Cook', nameZh: '主廚/料理', keywords: ['chef', 'cook', 'food'], hot: true },
  { char: '🍳', name: 'Cooking', nameZh: '煎炸/早餐', keywords: ['egg', 'pan', 'fry'] },
  { char: '🥘', name: 'Shallow Pan', nameZh: '燉煮/豐盛', keywords: ['food', 'stew', 'dinner'] },
  { char: '🍲', name: 'Pot of Food', nameZh: '暖心鍋物', keywords: ['soup', 'hot', 'winter'], hot: true },
  { char: '🥣', name: 'Bowl with Spoon', nameZh: '麥片/湯品', keywords: ['cereal', 'eat', 'morning'] },
  { char: '🔪', name: 'Knife', nameZh: '切配/主廚刀', keywords: ['cut', 'sharp', 'cook'] },
  { char: '🧂', name: 'Salt', nameZh: '調味/加點料', keywords: ['spice', 'taste', 'flavor'] },
  { char: '🥖', name: 'Baguette', nameZh: '烘焙手作', keywords: ['bread', 'bake', 'france'] },
  { char: '🍰', name: 'Cake', nameZh: '精緻甜點', keywords: ['sweet', 'dessert', 'bake'], hot: true },
  { char: '🥐', name: 'Croissant', nameZh: '早午餐', keywords: ['brunch', 'bread', 'morning'] },
  { char: '🍽️', name: 'Plate', nameZh: '擺盤美學', keywords: ['dinner', 'eat', 'table'] },
  { char: '🥂', name: 'Cheers', nameZh: '儀式感', keywords: ['drink', 'celebrate', 'party'], hot: true },
];